import Api from '../../library/api';
import { showError } from '../snackbars/snackbars-actions';

export const REQUEST_RESET_PASSWORD = 'REQUEST_RESET_PASSWORD';
export const RESET_PASSWORD_FAILED = 'RESET_PASSWORD_FAILED';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';


export function resetPassword(email, responseCallback) {
  return dispatch => {


    dispatch({ type: REQUEST_RESET_PASSWORD });

    Api.post('p/reset-password', { email }, responseCallback)
      .then(resp => {

        console.log({ resp })
        if (resp.err) {
          dispatch({ type: RESET_PASSWORD_FAILED });
          dispatch(showError(resp.err));
          return
        } else {
          responseCallback(true)
        }

        // "admin": false,
        // "role": "Owner",
        // "business": true,
        // "business_name": "Enjoy Space"

        resp.permissions = {
          admin: resp.admin
        };

        dispatch({
          type: RESET_PASSWORD_SUCCESS,
          payload: resp
        })

      });

  }
}



// WEBPACK FOOTER //
// ./src/components/reset-password/reset-password-actions.js